/*
 * Synchronisation de la galerie produit, Ruban Paris.
 *
 * Defauts corriges le 16 aout, tous constates en mesurant :
 *
 * 1. LES VIGNETTES NE SUIVAIENT PAS LE GLISSEMENT. Aucun ecouteur de scroll
 *    n'etait pose sur la bande principale.
 *
 * 2. LE RECALAGE COUPAIT L'ANIMATION. On attend desormais que le defilement
 *    soit REELLEMENT arrete avant de corriger.
 *
 * 3. LA CIBLE DEPENDAIT DU offsetParent. On mesure via getBoundingClientRect.
 *
 * 4. LES IMAGES NON CHARGEES DONNAIENT UNE CASE VIDE. Voir precharger().
 *
 * Expose window.rpGalleryGoTo(galerie, racine, index), signature inchangee.
 */
(function () {
  'use strict';

  /* Diapo dont le bord gauche est le plus proche du bord gauche de la bande. */
  function indexVisible(gal) {
    var diapos = gal.querySelectorAll('[data-idx]');
    var gauche = gal.getBoundingClientRect().left;
    var best = 0, meilleure = Infinity;
    for (var i = 0; i < diapos.length; i++) {
      var d = Math.abs(diapos[i].getBoundingClientRect().left - gauche);
      if (d < meilleure) { meilleure = d; best = parseInt(diapos[i].dataset.idx, 10); }
    }
    return best;
  }

  /*
   * PRECHARGEMENT FORCE, ajoute le 16 aout.
   *
   * Les diapos de la galerie sont en loading="lazy" sauf la premiere. Or le
   * chargement differe ne se declenche pas de facon fiable sur ce theme
   * (piege 14). Mesure : 10 images sur 15 n'etaient JAMAIS chargees, dont les
   * deux colliers Noeud d'amour. Sauter sur une de ces diapos affichait une
   * case vide, et c'est ce que Jonas voyait en cliquant une carte.
   *
   * On ne repasse pas toute la galerie en eager, ce qui alourdirait le premier
   * affichage de 15 images : on force uniquement la diapo visee et ses deux
   * voisines, au moment ou on en a besoin.
   */
  function forcer(img) {
    if (!img || (img.complete && img.naturalWidth > 0)) return;
    /*
     * Depuis le 15 septembre, les diapos apres la premiere n'ont PAS de src :
     * l'adresse attend dans data-src et n'est posee qu'ici, pour la diapo visee
     * et ses deux voisines (voir rp-main-product.liquid).
     */
    if (!img.getAttribute('src') && img.dataset.src) {
      img.setAttribute('src', img.dataset.src);
      return;
    }
    img.loading = 'eager';
    img.setAttribute('fetchpriority', 'high');
    /* Certains moteurs ne relancent rien sur le seul changement d'attribut :
       reaffecter src declenche le telechargement a coup sur. */
    var s = img.getAttribute('src');
    if (s) img.setAttribute('src', s);
  }

  function precharger(gal, i) {
    if (!gal) return;
    for (var k = i - 1; k <= i + 1; k++) {
      if (k < 0) continue;
      var d = gal.querySelector('[data-idx="' + k + '"]');
      if (d) forcer(d.querySelector('img'));
    }
  }

  /*
   * Amene la vignette active dans le champ, que la bande soit horizontale
   * (mobile, vignettes sous l'image) ou verticale (desktop, vignettes a gauche).
   */
  function rendreVisible(t) {
    var bande = t.parentElement;
    if (!bande) return;
    var rt = t.getBoundingClientRect(), rb = bande.getBoundingClientRect();
    if (bande.scrollWidth > bande.clientWidth + 2) {
      if (rt.left < rb.left) bande.scrollLeft -= (rb.left - rt.left);
      else if (rt.right > rb.right) bande.scrollLeft += (rt.right - rb.right);
    }
    if (bande.scrollHeight > bande.clientHeight + 2) {
      if (rt.top < rb.top) bande.scrollTop -= (rb.top - rt.top);
      else if (rt.bottom > rb.bottom) bande.scrollTop += (rt.bottom - rb.bottom);
    }
  }

  function marquer(root, i) {
    if (!root) return;
    var vignettes = root.querySelectorAll('.rp-thumb');
    for (var k = 0; k < vignettes.length; k++) {
      var t = vignettes[k];
      var actif = parseInt(t.dataset.goto, 10) === i;
      if (actif !== t.classList.contains('rp-thumb--active')) {
        t.classList.toggle('rp-thumb--active', actif);
      }
      if (actif) rendreVisible(t);
    }
  }

  window.rpGalleryGoTo = function (gal, root, i) {
    if (!gal || i === null || i === undefined || i < 0) return;
    var diapo = gal.querySelector('[data-idx="' + i + '"]');
    if (!diapo) return;

    /* Avant tout : que l'image de destination existe a l'ecran. */
    precharger(gal, i);

    var cible = Math.round(
      diapo.getBoundingClientRect().left - gal.getBoundingClientRect().left + gal.scrollLeft
    );

    /*
     * Le drapeau rpCible neutralise l'ecouteur de scroll tant que le
     * defilement est pilote par un clic : sans lui, la vignette active
     * defilait a travers toutes les diapos traversees par l'animation.
     *
     * Annuler toute surveillance encore en cours AVANT d'en lancer une neuve.
     * Sans ca, deux appels rapproches se marchent dessus : la surveillance du
     * premier garde son ancienne cible en fermeture et ramene la galerie en
     * arriere.
     */
    if (gal.rpMontre) { clearInterval(gal.rpMontre); gal.rpMontre = null; }
    if (gal.rpDemarrage) { clearTimeout(gal.rpDemarrage); gal.rpDemarrage = null; }
    if (gal.rpAbandon) { clearTimeout(gal.rpAbandon); gal.rpAbandon = null; }

    gal.rpCible = i;

    var avant = Math.round(gal.scrollLeft);
    try { gal.scrollTo({ left: cible, behavior: 'smooth' }); }
    catch (e) { gal.scrollLeft = cible; }

    /*
     * SMOOTH N'EST PAS TOUJOURS HONORE. Mesure du 16 aout : scrollTo avec
     * behavior 'smooth' ne deplace pas d'un seul pixel, meme apres 800ms,
     * alors que scrollLeft en affectation directe fonctionne. On regarde donc
     * au tick suivant si le defilement a seulement DEMARRE, et on positionne
     * sec sinon.
     */
    gal.rpDemarrage = setTimeout(function () {
      if (Math.abs(Math.round(gal.scrollLeft) - avant) < 2 && Math.abs(avant - cible) > 2) {
        gal.scrollLeft = cible;
        gal.rpCible = null;
      }
    }, 120);

    var dernier = null, immobile = 0;
    var montre = setInterval(function () {
      var x = Math.round(gal.scrollLeft);
      if (Math.abs(x - cible) <= 2) { clearInterval(montre); gal.rpCible = null; return; }
      immobile = (x === dernier) ? immobile + 1 : 0;
      dernier = x;
      if (immobile >= 3) { gal.scrollLeft = cible; clearInterval(montre); gal.rpCible = null; }
    }, 80);
    gal.rpMontre = montre;
    gal.rpAbandon = setTimeout(function () { clearInterval(montre); gal.rpCible = null; }, 2000);

    marquer(root, i);
  };

  /*
   * Ecouteur de defilement. Volontairement en setTimeout et NON en
   * requestAnimationFrame : rAF ne s'execute pas du tout dans le navigateur de
   * test (piege 27), la synchro ne partait donc jamais.
   */
  function brancher(gal) {
    if (gal.dataset.rpSync) return;
    gal.dataset.rpSync = '1';
    var root = gal.closest('.rp-product') || document;
    var enAttente = false;
    gal.addEventListener('scroll', function () {
      if (gal.rpCible != null) return;      /* un clic pilote : on n'ecrase pas */
      if (enAttente) return;
      enAttente = true;
      setTimeout(function () {
        enAttente = false;
        if (gal.rpCible != null) return;
        var v = indexVisible(gal);
        precharger(gal, v);   /* un glissement au doigt doit aussi charger */
        marquer(root, v);
      }, 60);
    }, { passive: true });
    var depart = indexVisible(gal);
    precharger(gal, depart);
    marquer(root, depart);
  }

  /*
   * CLIC SUR UNE CARTE MESSAGE : amener sa photo dans la galerie.
   *
   * Une variante Shopify ne porte qu'UNE image, et ici elle sert deja au couple
   * collier + couleur. Les trois cartes d'une meme finition pointent donc
   * toutes vers la meme photo de collier : cliquer "A ma Maman" ne deplacait
   * pas la galerie alors que la photo de la carte est bien presente.
   *
   * On rattrape ca ici et NON dans rp-bundle.liquid, pour ne pas toucher au
   * fichier qui compose le panier. On associe la valeur d'option au media dont
   * le texte alternatif est celui d'une carte ("Carte message A ma Maman").
   *
   * ATTENTION : ce rapprochement depend du texte alternatif des medias, qui
   * doit rester de la forme "Carte message A ma X". Le modifier dans l'admin
   * Shopify casse la fonction SANS aucun signal.
   */

  /*
   * Volontairement SANS echappement unicode : une plage de codes ecrite en
   * sequences d'echappement s'etait retrouvee decodee en vrais caracteres
   * combinants invisibles dans le source. On filtre par code de caractere.
   */
  function normaliser(s) {
    var bas = (s || '').toString().normalize('NFD').toLowerCase();
    var out = '';
    for (var i = 0; i < bas.length; i++) {
      var c = bas.charCodeAt(i);
      out += ((c >= 97 && c <= 122) || (c >= 48 && c <= 57)) ? bas.charAt(i) : '-';
    }
    return out.replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function cartesDeLaGalerie(gal) {
    var map = {};
    var diapos = gal.querySelectorAll('[data-idx]');
    for (var i = 0; i < diapos.length; i++) {
      var img = diapos[i].querySelector('img');
      if (!img) continue;
      var m = normaliser(img.getAttribute('alt')).match(/^carte-message-(.+)$/);
      if (m) map[m[1]] = parseInt(diapos[i].dataset.idx, 10);
    }
    return map;
  }

  /*
   * En phase de bulle et avec 60ms de retard : le selecteur d'offre traite son
   * propre clic d'abord et repositionne la galerie sur l'image de variante,
   * qui pour un changement de carte est INCHANGEE. Sans ce decalage il
   * annulerait notre saut.
   */
  /*
   * Le rapprochement carte -> media est expose : le selecteur d'offre s'en sert
   * pour amener la galerie sur la carte choisie, coffret par coffret, ce que cet
   * ecouteur delegue ne savait pas faire faute de connaitre le coffret clique.
   * Renvoie null quand la valeur ne designe aucune carte.
   */
  window.rpCarteMediaIndex = function (gal, valeur) {
    if (!gal) return null;
    var idx = cartesDeLaGalerie(gal)[normaliser(valeur)];
    return (idx === undefined) ? null : idx;
  };

  document.addEventListener('click', function (e) {
    /*
     * PASTILLES DE LA FICHE UNIQUEMENT, depuis le 13 septembre. Le selecteur
     * d'offre pilote la galerie lui-meme, coffret par coffret. Laisser cet
     * ecouteur prendre aussi les pastilles du bundle ([data-bd-val]) le faisait
     * repartir 60 ms apres chaque clic et ramener la galerie sur la carte alors
     * qu'on venait de choisir un collier.
     */
    var btn = e.target && e.target.closest ? e.target.closest('[data-val]') : null;
    if (!btn) return;
    if (btn.closest('[data-bd-unit]')) return;
    var valeur = normaliser(btn.dataset.val);
    if (!valeur) return;
    setTimeout(function () {
      var gal = document.querySelector('.rp-gallery__main');
      if (!gal) return;
      var idx = cartesDeLaGalerie(gal)[valeur];
      if (idx == null) return;
      window.rpGalleryGoTo(gal, gal.closest('.rp-product') || document, idx);
    }, 60);
  });

  function init() {
    var bandes = document.querySelectorAll('.rp-gallery__main');
    for (var i = 0; i < bandes.length; i++) brancher(bandes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* L'editeur de theme re-injecte la section sans recharger la page. */
  document.addEventListener('shopify:section:load', init);
})();
